var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoordinationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.71,
    height: 20.711,
    viewBox: "0 0 20.71 20.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3169",
    "data-name": "Group 3169",
    transform: "translate(0.354 0.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M27.031,30.192a2.916,2.916,0,1,1,2.916,2.916A2.916,2.916,0,0,1,27.031,30.192Z",
    transform: "translate(-19.979 -20.158)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1704",
    "data-name": "Line 1704",
    x1: 6.181,
    y2: 6.182,
    transform: "translate(13.821 0)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M56.559,12.632H52.634V8.707",
    transform: "translate(-38.814 -6.498)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1705",
    "data-name": "Line 1705",
    y1: 6.182,
    x2: 6.181,
    transform: "translate(-0.001 13.822)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M8.887,52.815h3.925V56.74",
    transform: "translate(-6.632 -38.945)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1706",
    "data-name": "Line 1706",
    x2: 6.181,
    y2: 6.182,
    transform: "translate(-0.001 0)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M12.632,8.887v3.926H8.707",
    transform: "translate(-6.499 -6.631)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1707",
    "data-name": "Line 1707",
    x1: 6.181,
    y1: 6.182,
    transform: "translate(13.821 13.822)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M52.815,56.56V52.634H56.74",
    transform: "translate(-38.946 -38.812)",
    fill: "none",
    stroke: "#00b5e2",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinationIcon);
export default __webpack_public_path__ + "static/media/CoordinationIcon.bd631a559afc5459e35f33f7162985d6.svg";
export { ForwardRef as ReactComponent };